module.exports = __webpack_public_path__ + "img/egg-poultry.627fc702.svg";